import { schedulePostHogInit } from "./lib/analytics/posthog";

schedulePostHogInit();
